import React, { useRef, useEffect, useCallback } from 'react';
import styles from '../Input/input.module.css';
import selectStyles from './select.module.css';
import ReactSelect, { components } from 'react-select';
import CreatableReactSelect from 'react-select/creatable';
import { useNavigate } from 'react-router-dom';
import icon from '../../brand/generated/buttonIcons/plus.svg';
import { colors } from '../../constants/colors';
import Hint from '../Hint';

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      <AddUserOption />
    </components.NoOptionsMessage>
  );
};

const AddOptionRow = ({ text, onClick, onMouseDown }) => (
  <div
    style={{ display: 'flex', alignItems: 'flex-start', columnGap: '12px', cursor: 'pointer', padding: 10 }}
    onClick={onClick}
    onMouseDown={onMouseDown}
  >
    <img src={icon} alt="Icon" />
    <p style={{ textDecoration: 'underline', color: colors.cameo }}>{text}</p>
  </div>
);

const AddUserOption = () => {
  const navigate = useNavigate();
  return <AddOptionRow text="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²Ð¾Ð³Ð¾ ÐºÐ»Ð¸ÐµÐ½ÑÐ°" onClick={() => navigate('/client/create')} />;
};

// ÐÐ¾ÑÐ»ÐµÐ´Ð½ÑÑ ÑÑÑÐ¾ÐºÐ° ÑÐ¿Ð¸ÑÐºÐ° Â«ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ...Â»: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ ÑÐ½Ð°ÑÐ°Ð»Ð° ÑÐ¼Ð¾ÑÑÐ¸Ñ, ÐµÑÑÑ Ð»Ð¸
// Ð½ÑÐ¶Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, Ð¸ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ¾Ð¼ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ Ð½Ð¾Ð²Ð¾Ðµ. ÐÐµÐ½Ñ Ð·Ð°ÐºÑÑÐ²Ð°ÐµÐ¼ ÑÑÐºÐ°Ð¼Ð¸ â
// Ð¾Ð½Ð¾ Ð²Ð¸ÑÐ¸Ñ Ð² Ð¿Ð¾ÑÑÐ°Ð»Ðµ Ñ z-index Ð²ÑÑÐµ Ð¼Ð¾Ð´Ð°Ð»ÐºÐ¸, ÐºÐ¾ÑÐ¾ÑÑÑ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº.
const AddDictionaryOption = ({ selectProps }) => (
  <AddOptionRow
    text={selectProps.addOptionLabel}
    // preventDefault Ð½Ð° mousedown: Ð¸Ð½Ð°ÑÐµ ÑÐ¾ÐºÑÑ ÑÑÐ¾Ð´Ð¸Ñ Ñ Ð¸Ð½Ð¿ÑÑÐ°, Ð¼ÐµÐ½Ñ
    // Ð·Ð°ÐºÑÑÐ²Ð°ÐµÑÑÑ ÐµÑÑ Ð´Ð¾ click Ð¸ Ð¾Ð±ÑÐ°Ð±Ð¾ÑÑÐ¸Ðº Ð½Ðµ ÑÑÐ¿ÐµÐ²Ð°ÐµÑ ÑÑÐ°Ð±Ð¾ÑÐ°ÑÑ.
    onMouseDown={(e) => e.preventDefault()}
    onClick={() => {
      document.activeElement?.blur?.();
      selectProps.onAddOption();
    }}
  />
);

const MenuListWithSentinel = ({ children, innerRef: innerRefProp, selectProps, ...props }) => {
  const sentinelRef = useRef(null);
  const containerRef = useRef(null);
  const onBottomRef = useRef(null);
  const prevIsLoadingRef = useRef(null);
  const optionsCountRef = useRef(0);

  onBottomRef.current = selectProps?.onScrollToBottom;
  optionsCountRef.current = selectProps?.options?.length ?? 0;

  const setContainerRef = useCallback(
    (el) => {
      containerRef.current = el;
      if (typeof innerRefProp === 'function') innerRefProp(el);
      else if (innerRefProp && 'current' in innerRefProp) innerRefProp.current = el;
    },
    [innerRefProp]
  );

  const tryLoadMore = useCallback(() => {
    const sentinel = sentinelRef.current;
    const container = containerRef.current;
    if (!sentinel || !container || !onBottomRef.current) return;
    // ÐÑÑÑÐ¾Ð¼Ñ ÑÐ¿Ð¸ÑÐºÑ Ð½ÐµÑÐµÐ³Ð¾ Ð´Ð¾Ð³ÑÑÐ¶Ð°ÑÑ. Ð¡ÐµÐ½ÑÐ¸Ð½ÐµÐ» Ð¿ÑÐ¸ ÑÑÐ¾Ð¼ Ð²Ð¸ÑÐ¸Ñ Ð² ÑÐ°Ð¼Ð¾Ð¼ Ð²ÐµÑÑÑ
    // ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ°, ÑÐ¾ ÐµÑÑÑ Â«Ð½Ð¸Ð· Ð´Ð¾ÑÑÐ¸Ð³Ð½ÑÑÂ» Ð²ÑÐµÐ³Ð´Ð° â Ð¸ onScrollToBottom Ð´ÑÑÐ³Ð°Ð»ÑÑ
    // Ð±Ñ Ð¿Ð¾ÑÐ»Ðµ ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸, Ð·Ð°ÑÐ¸ÐºÐ»Ð¸Ð²Ð°Ñ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº, ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð²ÐµÑÐ½ÑÐ» [].
    // ÐÐµÑÐ²ÑÑ ÑÑÑÐ°Ð½Ð¸ÑÑ ÑÑÐ½ÐµÑ onMenuOpen, Ð° Ð½Ðµ ÑÑÐ¾Ñ Ð¿ÑÑÑ.
    if (!optionsCountRef.current) return;
    const containerRect = container.getBoundingClientRect();
    const sentinelRect = sentinel.getBoundingClientRect();
    if (sentinelRect.top < containerRect.bottom + 100) {
      onBottomRef.current();
    }
  }, []);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    const container = containerRef.current;
    if (!sentinel || !container || !onBottomRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) tryLoadMore();
      },
      { root: container, rootMargin: '0px 0px 100px 0px', threshold: 0 }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [tryLoadMore]);

  const isLoading = selectProps?.isLoading;
  const optionsCount = selectProps?.options?.length ?? 0;

  useEffect(() => {
    const prevIsLoading = prevIsLoadingRef.current;
    prevIsLoadingRef.current = isLoading;
    if (prevIsLoading === true && !isLoading) {
      tryLoadMore();
    }
  }, [isLoading, optionsCount, tryLoadMore]);

  const showBottomLoader = isLoading && optionsCount > 0;

  return (
    <components.MenuList {...props} selectProps={selectProps} innerRef={setContainerRef}>
      {children}
      {selectProps?.isAddClient && <AddUserOption />}
      {selectProps?.onAddOption && <AddDictionaryOption selectProps={selectProps} />}
      {showBottomLoader && (
        <div className={selectStyles.menuLoader}>
          <div className={selectStyles.menuLoaderSpinner} />
        </div>
      )}
      <div ref={sentinelRef} />
    </components.MenuList>
  );
};

const useIsTablet = () => {
  const [isTablet, setIsTablet] = React.useState(window.innerWidth <= 1250);
  React.useEffect(() => {
    const onResize = () => setIsTablet(window.innerWidth <= 1250);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isTablet;
};

const Select = ({
  style,
  title,
  label,
  placeholder,
  options,
  state,
  defaultValue,
  handleSetState,
  handleSetSelect,
  isSearchable = false,
  onFocus,
  isAddClient,
  isMulti,
  disabled,
  onChange,
  value,
  error,
  required,
  isLoading = false,
  hint,
  onChangeCustom,
  creatable,
  ...props
}) => {
  const isTablet = useIsTablet();

  const customTheme = (theme) => {
    return {
      ...theme,
      borderRadius: '0px',
      colors: {
        ...theme.colors,
        primary: colors.cameo,
        primary25: '#F2F2F2',
        primary50: '#F2F2F2',
      },
    };
  };

  // creatable â Ð¾Ð¿ÑÐ¸Ð¾Ð½Ð°Ð»ÑÐ½Ð¾: Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐµÑ Ð²Ð²ÐµÑÑÐ¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð½ÐµÑ Ð²
  // options (react-select/creatable), Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ ÐºÐ¾Ð³Ð´Ð° ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº ÐµÑÑ Ð½Ðµ
  // ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÑÐ¶Ð½ÑÐ¹ Ð²Ð°ÑÐ¸Ð°Ð½Ñ, Ð° Ð±ÑÐº Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð»ÑÐ½ÑÐ¹ ÑÐµÐºÑÑ (title) Ð¸
  // ÑÐ°Ð¼ Ð·Ð°Ð²Ð¾Ð´Ð¸Ñ Ð·Ð°Ð¿Ð¸ÑÑ Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸. ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð¼ÐµÐ½ÑÐµÑ Ð´Ð»Ñ ÑÑÑÐµÑÑÐ²ÑÑÑÐ¸Ñ
  // Ð¼ÐµÑÑ Ð¸ÑÐ¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°Ð½Ð¸Ñ Select, Ð³Ð´Ðµ ÑÑÐ¾Ñ Ð¿ÑÐ¾Ð¿ Ð½Ðµ Ð¿ÐµÑÐµÐ´Ð°ÑÑÑÑ
  const SelectComponent = creatable ? CreatableReactSelect : ReactSelect;

  React.useEffect(() => {}, [defaultValue]);
  return (
    <div className={styles.customInput}>
      <p>
        {title || label} {required && <span style={{ color: colors.red }}>*</span>}
        {hint && <Hint text={hint} />}
      </p>
      <SelectComponent
        components={{ MenuList: MenuListWithSentinel }}
        isSearchable={isSearchable}
        defaultValue={defaultValue}
        value={value}
        onInputChange={(e, meta) => {
          // meta Ð½ÑÐ¶ÐµÐ½, ÑÑÐ¾Ð±Ñ Ð¾ÑÐ»Ð¸ÑÐ¸ÑÑ ÑÐµÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð²Ð¾Ð´ Ð¾Ñ ÑÐ±ÑÐ¾ÑÐ° ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÐ¸
          // Ð·Ð°ÐºÑÑÑÐ¸Ð¸ Ð¼ÐµÐ½Ñ â Ð¸Ð½Ð°ÑÐµ ÑÐµÐ»ÐµÐºÑÑ Ñ ÑÐµÑÐ²ÐµÑÐ½ÑÐ¼ Ð¿Ð¾Ð¸ÑÐºÐ¾Ð¼ Ð¿ÐµÑÐµÐ·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÑÑ
          // ÑÐ¿Ð¸ÑÐ¾Ðº Ð¿Ð¾ÑÐ»Ðµ ÐºÐ°Ð¶Ð´Ð¾Ð³Ð¾ Ð²ÑÐ±Ð¾ÑÐ°. Ð¡ÑÐ°ÑÑÐµ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»Ð¸ Ð²ÑÐ¾ÑÐ¾Ð¹ Ð°ÑÐ³ÑÐ¼ÐµÐ½Ñ
          // Ð¿ÑÐ¾ÑÑÐ¾ Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÑÑÑ.
          if (handleSetSelect) handleSetSelect(e, meta);
        }}
        options={options}
        onChange={(val) => {
          if (handleSetState) {
            handleSetState(val);
          }
          if (onChange) {
            onChange(val);
          }
          if (onChangeCustom) {
            onChangeCustom(val);
          }
        }}
        placeholder={placeholder}
        classNames={{ control: (state) => (isMulti ? 'custom-select-multi' : 'custom-select') }}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused ? colors.cameo : error ? colors.red : colors.alto,
            backgroundColor: state.isDisabled ? `${colors.disabled} !important` : colors.backgroung,
            minHeight: isTablet ? '52px' : '44px',
            maxHeight: isMulti ? 'auto' : (isTablet ? '52px' : '44px'),
            boxShadow: '0px',
          }),
          option: (base) => ({ ...base, fontSize: '16px', padding: isTablet ? '12px 14px' : '10px 12px' }),
          singleValue: (base) => ({ ...base, fontSize: '16px' }),
          placeholder: (base) => ({ ...base, fontSize: '16px' }),
          input: (base) => ({ ...base, fontSize: '16px' }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        onScrollToBottom={onFocus}
        isAddClient={isAddClient}
        theme={customTheme}
        isMulti={isMulti ? isMulti : false}
        isDisabled={disabled}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        isLoading={isLoading}
        onMenuOpen={() => {
          onFocus && onFocus();
        }}
        {...props}
      />
    </div>
  );
};

export default Select;
